/**
 * Created by Rodrigo Quesada on 20/03/17.
 */

export class Page<T> {

    readonly results: T[];
    readonly page: number;
    readonly hasNext: boolean;
    readonly nextPage: number;
    readonly hasPrevious: boolean;
    readonly previousPage: number;

    constructor(data: any|Page<any> = {}, transformResultEntry: (entry: any) => T) {
        Object.assign(this, data);
        this.results = this.results.map(transformResultEntry);
    }

    map<R>(transform: (T) => R): Page<R> { return new Page<R>(this, transform); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/search/page.class.ts